export function isJerseyPostcode(postcode: string) {
  return !!(postcode && /^JE[1-5]/i.test(postcode.trim()));
}
